var exports = {
  "D": "x2b2fbebb--f78dd6--title",
  "O": "x2b2fbebb--f78dd6--rating",
};

module.exports = exports;
